import {formatPrice} from '../../../utils/common'

export const dataToOrderAuditList = (data: any[]) => {
  return data.map((item) => ({
    id: item.id,
    date: item.order_date,
    order_id: item.order_id,
    customer: {
      id: item.customer_id,
      name: item.customer_name,
      email: item.customer_email,
    },
    representative: {
      name: item.sales_rep_name,
      email: item.sales_rep_email,
    },
    status: item.order_status,
    total: formatPrice(item.total_inc_tax, false),
    archived_by: item.archived_by || '-',
    note: item.note || '-',
    last_updated_by: item.updated_by || '-',
    last_updated_date: item.updated_at,
  }))
}
